/* global axios */
import ApiClient from './ApiClient';

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  // O `delete` herdado não manda params. `disconnect_inboxes` é o "desconectar
  // e excluir": o backend recusa apagar um bot ativo numa caixa, e este é o
  // consentimento explícito para desfazer o vínculo junto.
  delete(id, { disconnectInboxes = false } = {}) {
    const config = disconnectInboxes
      ? { params: { disconnect_inboxes: true } }
      : undefined;
    return axios.delete(`${this.url}/${id}`, config);
  }
}

export default new AgentBotsAPI();
